/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q4Inputs */

const en_to_csv_faq_q4 = /** @type {(inputs: To_Csv_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert a single JSON object (not an array)?`)
};

const ko_to_csv_faq_q4 = /** @type {(inputs: To_Csv_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열이 아닌 단일 JSON 객체도 변환할 수 있나요?`)
};

const ja_to_csv_faq_q4 = /** @type {(inputs: To_Csv_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一のJSONオブジェクト（配列ではなく）を変換できますか？`)
};

/**
* | output |
* | --- |
* | "Can I convert a single JSON object (not an array)?" |
*
* @param {To_Csv_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q4 = /** @type {((inputs?: To_Csv_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q4(inputs)
	if (locale === "ko") return ko_to_csv_faq_q4(inputs)
	return ja_to_csv_faq_q4(inputs)
});